function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".eeaa3634-8df3-483e-9b6f-3e09b7c74d4d{fill:none;stroke:#f65e5c;stroke-width:12px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "b068e812-e9f4-4b68-bd8e-4b588d2ee0f8",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "f197731b-eac4-4547-b0a7-b03a8fbaa388",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "eeaa3634-8df3-483e-9b6f-3e09b7c74d4d",
  d: "M6,165.4H6a86,86,0,1,0,85.9-90A84.94,84.94,0,0,0,41.6,91.7L16.9,6H6V165.4Z"
})));

var SvgLogoIcon4 = function SvgLogoIcon4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 183.9 253.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoIcon4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-icon (4).e95b27ef.svg";
export { ForwardRef as ReactComponent };